module.exports = __webpack_public_path__ + "img/Réalisation marquise a plat.3502a866.jpg";